import styled from "styled-components";

export const Container = styled.button`

    width:100%;
    background-color: transparent;

`;